module.exports = __webpack_public_path__ + "static/media/icon_nodata.853f09ab.svg";